<template>
  <Modal v-model="automaticRulesModal" :title="title" width="600">
    <Form ref="formInline" :model="formParams" :rules="rules" :label-width="labelWidth" @submit.native.prevent>
      <FormItem prop="platformIds" :label="$t('key1005351')">
        <Select
          v-model="formParams.platformIds"
          filterable
          :placeholder="$t('key1005631')"
          class="ipt-i"
          :max-tag-count="maxTagCount"
          :maxTagPlaceholder="platformValueText"
          @on-change="platformChange"
          multiple>
          <Option value="_All">{{ $t('key1000110') }}</Option>
          <Option v-for="item in platformList" :value="item.platformId">{{ item.name }}</Option>
        </Select>
      </FormItem>
      <FormItem prop="ymsDeliveryPlaceId">
        <template #label>
          <span class="mr5">{{ $t('key1005616') }}</span>
        </template>
        <Select v-model="formParams.ymsDeliveryPlaceId" class="ipt-i">
          <template v-for="item in placeOfShipmentList">
            <Option :value="item.ymsDeliveryPlaceId"
              :disabled="formParams.ymsInventorySynRuleDetails.some(i => i.ymsDeliveryPlaceId === item.ymsDeliveryPlaceId)">
              {{ item.deliveryPlaceName }}
            </Option>
          </template>
        </Select>
      </FormItem>
      <FormItem v-for="(item, index) in formParams.ymsInventorySynRuleDetails" :key="index" class="reset-form-label">
        <template #label>
          <Select v-model="item.operator" class="w60">
            <Option value="+">+</Option>
            <Option value="-">-</Option>
          </Select>
        </template>
        <div style="display: flex;align-items: center">
          <Select v-model="item.ymsDeliveryPlaceId" class="ipt-i">
            <template v-for="item in placeOfShipmentList">
              <Option :value="item.ymsDeliveryPlaceId"
                :disabled="formParams.ymsInventorySynRuleDetails.some(i => i.ymsDeliveryPlaceId === item.ymsDeliveryPlaceId) || formParams.ymsDeliveryPlaceId === item.ymsDeliveryPlaceId">
                {{ item.deliveryPlaceName }}
              </Option>
            </template>
          </Select>
          <Icon type="md-trash" class="del-icon" @click="formParams.ymsInventorySynRuleDetails.splice(index,1)"/>
        </div>
      </FormItem>
      <p class="add-rule font-size-12" @click="addRule">{{ $t('key1005441') }}</p>
      <FormItem>
        <template #label>
          <Tooltip
            transfer
            max-width="300"
            :content="$t('key1005643')"
            placement="top">
            <Icon class="cursor mr5" size="16" type="ios-help-circle-outline"/>
          </Tooltip>
          {{ $t('key1005645') }}
        </template>
        <InputNumber :max="100" :min="0" class="ipt-i" v-model="formParams.floatDown" :formatter="value => `${value}%`"
          :parser="value => value.replace('%', '')"></InputNumber>
      </FormItem>
      <FormItem>
        <template #label>
          <Tooltip transfer max-width="300" :content="$t('key1005644')" placement="top">
            <Icon class="cursor mr5" size="16" type="ios-help-circle-outline"/>
          </Tooltip>
          <span class="mr5">{{ $t('key1005616') }}</span>
        </template>
        <span class="font-size-12">{{ availableText }}</span>
      </FormItem>
      <FormItem>
        <template #label>
          {{ $t('key1005646') }}
        </template>
        <span class="font-size-12">{{ $t('key1005614') }}</span>
        <InputNumber class="w100" :active-change="false" :max="100000" :min="30"
          v-model="formParams.synTime" @on-blur="handleSynTime"></InputNumber>
        <span class="font-size-12">{{ $t('key1005615') }}</span>
      </FormItem>
      <FormItem class="radio_styles">
        <template #label>{{ $t('key1001522') }}</template>
        <RadioGroup v-model="formParams.status">
          <Radio :label="1">
            <span>{{ $t('key1000462') }}</span>
          </Radio>
          <Radio :label="0">
            <span>{{ $t('key1000463') }}</span>
          </Radio>
        </RadioGroup>
      </FormItem>
    </Form>
    <template #footer>
      <Button @click="automaticRulesModal = false">{{ $t('key1000112') }}</Button>
      <Button type="primary" :loading="btnLoading" @click="onSubmit">{{ $t('key1000111') }}</Button>
    </template>
  </Modal>
</template>

<script>
import aliasb03645cf6abd4d56a73b13687765a5d8 from '@/locale/i18nUtils.js';

import Mixin from '@/components/mixin/common_mixin';
import api from '@/api/';

export default {
  name: 'automaticRulesModal',
  mixins: [Mixin],
  props: {
    platformList: { // 适用平台
      type: Array,
      default: () => []
    },
    placeOfShipmentList: {
      type: Array
    }
  },
  data() {
    const validateByPlatformIds = (rule, value, callback) => {
      if (value.length === 0) {
        callback(new Error(aliasb03645cf6abd4d56a73b13687765a5d8.t('key1001347')));
      } else {
        callback();
      }
    };
    return {
      automaticRulesModal: false,
      btnLoading: false,
      unit: 1,
      title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1005441'),
      maxTagCount: 1,
      formParams: {
        ymsDeliveryPlaceId: null,
        floatDown: 0, // 向下浮动 ,
        platformIds: [], // 平台ids
        status: 1, // 状态 0：停用 1：启用（默认0）
        synTime: 30, //  同步时间
        timeType: 2, // 任务执行的固定周期的单位(1时,2分钟) ,
        ymsInventorySynRuleDetails: []
      },
      editType: 'add',
      rules: {
        platformIds: [
          {
            required: true,
            validator: validateByPlatformIds,
            trigger: 'change'
          }
        ],
        ymsDeliveryPlaceId: [
          {
            required: true,
            message: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1005638'),
            trigger: 'change'
          }
        ]
      }
    };
  },
  methods: {
    /**
     * 入口
     * @param editType 编辑类型 add edit look
     * @param ymsInventorySynRuleId 编辑类型 add edit look
     * */
    initAutomaticRulesData(editType, ymsInventorySynRuleId) {
      this.reset();
      this.editType = editType;
      if (editType !== 'add') {
        this.getDetails(ymsInventorySynRuleId);
      }
      this.title = editType === 'add' ? aliasb03645cf6abd4d56a73b13687765a5d8.t('key1005639') : aliasb03645cf6abd4d56a73b13687765a5d8.t('key1005640');
      this.automaticRulesModal = true;
    },
    /**
     * 同步时间blur事件
     */
    handleSynTime() {
      if (!this.formParams.synTime) {
        this.formParams.synTime = 30;
      }
    },
    reset() {
      if (this.$refs.formInline) {
        this.$refs.formInline.resetFields();
      }
      this.formParams.floatDown = 0;
      this.formParams.status = 1;
      this.formParams.synTime = 30;
      this.formParams.ymsInventorySynRuleDetails = [];
    },
    platformChange() {
      if (this.formParams.platformIds[this.formParams.platformIds.length - 1] === '_All') {
        this.formParams.platformIds = ['_All'];
        this.maxTagCount = 0;
        return;
      } else {
        this.formParams.platformIds = this.formParams.platformIds.filter(i => i !== '_All');
      }
      if (this.formParams.platformIds.length <= 1) {
        this.maxTagCount = 1;
      } else {
        this.maxTagCount = 0;
      }
    },
    platformValueText(len) {
      if (this.formParams.platformIds.includes('_All')) {
        len = this.platformList.length;
      }
      return aliasb03645cf6abd4d56a73b13687765a5d8.t('key1001425') + len + aliasb03645cf6abd4d56a73b13687765a5d8.t('key1005641');
    },
    // 获取详情数据
    getDetails(ymsInventorySynRuleId) {
      let v = this;
      v.axios.get(api.get_ymsInventorySynRule + ymsInventorySynRuleId).then(response => {
        if (response.data.code === 0) {
          let _data = response.data.datas;
          if (_data.ymsInventorySynRulePlatforms) {
            _data.platformIds = _data.ymsInventorySynRulePlatforms.map(i => i.platformId);
          }
          if (_data.ymsInventorySynRuleDetails && _data.ymsInventorySynRuleDetails.length) {
            _data.ymsDeliveryPlaceId = _data.ymsInventorySynRuleDetails.filter(i => i.sort === 0)[0].ymsDeliveryPlaceId;
            _data.ymsInventorySynRuleDetails = _data.ymsInventorySynRuleDetails.filter(i => i.sort !== 0);
          }
          v.formParams = _data;
        }
      });
    },
    addRule() {
      this.formParams.ymsInventorySynRuleDetails.push({
        operator: '+',
        ymsDeliveryPlaceId: null,
      });
    },
    onSubmit() {
      let v = this;
      v.$refs['formInline'].validate((valid) => {
        if (valid) {
          let {ymsDeliveryPlaceId, ...obj} = this.formParams;
          let params = JSON.parse(JSON.stringify(obj));
          params.ymsInventorySynRuleDetails.unshift({
            operator: '+',
            ymsDeliveryPlaceId: ymsDeliveryPlaceId
          });
          params.ymsInventorySynRuleDetails = params.ymsInventorySynRuleDetails.filter(i => i.ymsDeliveryPlaceId).map((i, index) => {
            i.sort = index;
            return i;
          });
          if (params.platformIds.includes('_All')) {
            params.platformIds = v.platformList.map(i => i.platformId);
          }
          let _api = v.editType === 'add' ? api.post_ymsInventorySynRule_insert : api.put_ymsInventorySynRule_update;
          let _apiType = v.editType === 'add' ? 'post' : 'put';
          v.btnLoading = true;
          v.axios[_apiType](_api, params).then(response => {
            v.btnLoading = false;
            if (response.data.code === 0) {
              let _text = v.editType === 'add' ? aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000456') : aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000839');
              v.$Message.success(_text);
              v.automaticRulesModal = false;
              v.$emit('success');
            }
          }).catch(() => {
            v.btnLoading = false;
          });
        }
      });
    }
  },
  computed: {
    availableText() {
      let v = this;
      if (this.formParams.ymsDeliveryPlaceId) {
        let params = this.formParams.ymsInventorySynRuleDetails ? JSON.parse(JSON.stringify(this.formParams.ymsInventorySynRuleDetails)) : [];
        params.unshift({
          ymsDeliveryPlaceId: this.formParams.ymsDeliveryPlaceId
        });
        params.forEach(i => {
          v.placeOfShipmentList.forEach(j => {
            if (i.ymsDeliveryPlaceId === j.ymsDeliveryPlaceId) {
              i.deliveryPlaceName = j.deliveryPlaceName;
            }
          });
        });
        let text = params.filter(i => i.ymsDeliveryPlaceId).reduce((a, b, index) => {
          if (index === 0) {
            a = b.deliveryPlaceName + aliasb03645cf6abd4d56a73b13687765a5d8.t('key1005642');
          } else {
            a = a + b.operator + b.deliveryPlaceName + aliasb03645cf6abd4d56a73b13687765a5d8.t('key1005642');
          }
          return a;
        }, 0);
        return `(${text}) *${100 - v.formParams.floatDown}%`;
      }
      return '';
    }
  }
};
</script>

<style>
.w60 {
  width: 60px;
}

.reset-form-label .ivu-form-item-label {
  padding: 0;
}

.reset-form-label .ivu-form-item-label:before {
  content: '';
  display: none;
}
</style>
<style scoped>

.w100 {
  width: 100px;
  margin: 0 4px;
}

.add-rule {
  margin-left: 120px;
  margin-bottom: 10px;
  color: #FF5310;
  cursor: pointer;
}

.del-icon {
  font-size: 16px;
  padding-left: 5px;
  cursor: pointer;
}

.del-icon:hover {
  color: red;
}

.ipt-i {
  width: 342px;
}
</style>
